export enum DistributorTypeEnum {
  BUSINESS_ENTITY = 'BUSINESS_ENTITY',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum DistributorTabStatus {
  REGISTERED = 'teregistrasi',
  PENDING = 'pending',
  REJECT = 'reject',
}

export enum DistributorRegisteredTabType {
  ACTIVE = 'active',
  REGISTERED = 'registered',
}

export enum DistributorPendingTabType {
  EDIT_REQUEST = 'edit-request',
  FINANCE_EDIT_REQUEST = 'finance-edit-request',
  PENDING_REGISTRATION = 'registration',
  PENDING_VERIFICATION = 'verification',
}

export enum DistributorDetailPendingStatus {
  PENDING_REGISTRATION = 'PENDING_REGISTRATION',
  PENDING_REGISTRATION_FINANCE = 'PENDING_REGISTRATION_FINANCE',
  PENDING_EDIT_VERIFICATION = 'PENDING_EDIT_VERIFICATION',
  PENDING_EDIT_VERIFICATION_FINANCE = 'PENDING_EDIT_VERIFICATION_FINANCE',
}

export enum DistributorPlafonKreditCardType {
  DETAIL_PLAFON = 'DETAIL_PLAFON',
  DETAIL_TARGET_PENJUALAN = 'DETAIL_TARGET_PENJUALAN',
  DETAIL_PENAGIHAN = 'DETAIL_PENAGIHAN',
}

export enum DistributorStatusEnumTabString {
  ACTIVE = 'active',
  REGISTERED = 'registered',
  EDIT_REQUEST = 'edit-request',
  REGISTRATION = 'registration',
  VERIFICATION = 'verification',
  NON_ACTIVE = 'non-active',
  LOG = 'log',
}

// sprint territory2 updated distributor statuses enum
export enum DistributorStatusEnum {
  ACTIVE = 'ACTIVE',
  REGISTERED = 'REGISTERED', // menunggu KUL
  // pendaftaran diproses
  PENDING_REGISTRATION = 'PENDING_REGISTRATION',
  PENDING_REGISTRATION_FINANCE = 'PENDING_REGISTRATION_FINANCE',
  // perubahan data diproses
  PENDING_EDIT_VERIFICATION = 'PENDING_EDIT_VERIFICATION',
  PENDING_EDIT_VERIFICATION_FINANCE = 'PENDING_EDIT_VERIFICATION_FINANCE',
  REGISTRATION_REJECTED = 'REGISTRATION_REJECTED',
  REGISTRATION_REJECTED_FINANCE = 'REGISTRATION_REJECTED_FINANCE',

  // verifikasi diproses
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  VERIFICATION_REJECTED = 'VERIFICATION_REJECTED',

  // non active
  NON_ACTIVATED = 'NONACTIVATED',
  PENDING_NONACTIVATED = 'PENDING_NONACTIVATED',
  REJECT_NONACTIVATED = 'REJECT_NONACTIVATED',
}

export enum DistributorStatusEnumString {
  ACTIVE = 'Aktif',
  REGISTERED = 'Menunggu KUL',
  PENDING_REGISTRATION = 'Pendaftaran Diproses Admin',
  PENDING_REGISTRATION_FINANCE = 'Pendaftaran Diproses Finance',
  PENDING_EDIT_VERIFICATION = 'Perubahan Data Diproses Admin',
  PENDING_EDIT_VERIFICATION_FINANCE = 'Perubahan Data Diproses Finance',
  REGISTRATION_REJECTED = 'Pendaftaran Ditolak Admin',
  REGISTRATION_REJECTED_FINANCE = 'Pendaftaran Ditolak Finance',
  PENDING_VERIFICATION = 'Verifikasi Diproses',
  VERIFICATION_REJECTED = 'Verifikasi Ditolak',
  NONACTIVATED = 'Nonaktif',
  PENDING_NONACTIVATED = 'Pengajuan Penonaktifan',
}

export enum PaymentMethodEnum {
  CREDIT_CEILING = 'CREDIT_CEILING',
  CASH_BEFORE_DELIVERY = 'CASH_BEFORE_DELIVERY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  CASH_CREDIT = 'CASH_CREDIT',
}

export enum StatusChangeEnum {
  ADD = 'ADD',
  UPDATED = 'UPDATED',
  NOT_CHANGE = 'NOT_CHANGE',
  DELETE = 'DELETE',
}
